import { render, staticRenderFns } from "./StudentRatingTeacher.vue?vue&type=template&id=07337d24&"
import script from "./StudentRatingTeacher.vue?vue&type=script&lang=js&"
export * from "./StudentRatingTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports